/**
 * GraphQL Query that fetches the list of products with details using sort,
 * filters and pagination.
 * Every attribute marked with # --- ADDED --- is custom, additional metadata.
 */
export default `
  query productDetails(
    $search: String = ""
    $filter: ProductAttributeFilterInput
    $pageSize: Int = 10
    $currentPage: Int = 1
    $sort: ProductAttributeSortInput
    $configurations: [ID!]
  ) {
    products(search: $search, filter: $filter, sort: $sort, pageSize: $pageSize, currentPage: $currentPage) {
      aggregations {
        attribute_code
        label
        options {
          label
          value
        }
      }
      items {
        pid: id
        uid
        sku
        name
        hreflang_data {
          rel
          language
          url
        }
        highlights # --- ADDED ---
        #brand # --- ADDED ---
        fit # --- ADDED ---
        colour_wheels {
          id
          sku
          name
          image
          url
        }
        special_note # --- ADDED ---
        style # --- ADDED ---
        #style_profile # --- ADDED ---
        date_online # --- ADDED ---
        product_label # --- ADDED ---
        product_urls {
          # --- ADDED ---
          en
          nl
          de
          fr
        }
        stock_status
        #only_x_left_in_stock
        price_range {
          maximum_price {
            final_price {
              currency
              value
            }
            regular_price {
              currency
              value
            }
          }
          minimum_price {
            final_price {
              currency
              value
            }
            regular_price {
              currency
              value
            }
          }
        }
        canonical_url # --- ADDED ---
        categories {
          id
          uid
          name
          url_suffix
          url_path
          breadcrumbs {
            category_id
            category_name
            category_url_path
          }
        }
        rating_summary
        review_count
        image {
          url
          position
          disabled
          label
        }
        media_gallery {
          url
          position
          disabled
          label
          # --- ADDED ---
          ... on ProductVideo {
            video_content {
              media_type
              video_provider
              video_url
              video_title
              video_description
              video_metadata
            }
          }
        }
        thumbnail {
          url
          position
          disabled
          label
        }
        #url_key
        meta_description
        meta_keyword
        meta_title
        description {
          html
        }
        #options_container
        #special_to_date
        ... on BundleProduct {
          items {
            position
            required
            sku
            title
            type
            uid
            options {
              can_change_quantity
              is_default
              position
              uid
              quantity
              product {
                uid
                sku
                name
                price_range {
                  maximum_price {
                    final_price {
                      currency
                      value
                    }
                    regular_price {
                      currency
                      value
                    }
                  }
                  minimum_price {
                    final_price {
                      currency
                      value
                    }
                    regular_price {
                      currency
                      value
                    }
                  }
                }
              }
            }
          }
        }
        ... on ConfigurableProduct {
          # --- ADDED ---
          variants {
            product {
              id
              sku
              type_id
              stock_status
              stock_indication
              thumbnail {
                label
                url
              }
            }
            attributes {
              uid
              label
              code
            }
          }
          configurable_options {
            attribute_code
            attribute_uid
            label
            position
            uid
            # use_default
            values {
              label
              swatch_data {
                value
              }
              uid
            }
          }
          configurable_product_options_selection(configurableOptionValueUids: $configurations) {
            variant {
              uid
            }
          }
        }
        ... on GroupedProduct {
          items {
            position
            qty
            product {
              uid
              sku
              name
              stock_status
              only_x_left_in_stock
              price_range {
                maximum_price {
                  final_price {
                    currency
                    value
                  }
                  regular_price {
                    currency
                    value
                  }
                }
                minimum_price {
                  final_price {
                    currency
                    value
                  }
                  regular_price {
                    currency
                    value
                  }
                }
              }
              thumbnail {
                url
                position
                disabled
                label
              }
            }
          }
        }
        ... on CustomizableProductInterface {
          options {
            title
            required
            sort_order
            uid
            option_id
            ... on CustomEngravingOption {
              field_option: value {
                max_characters
              }
            }
          }
        }
      }
    }
  }
`
